import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable()
export class ReportService {
    private reportServiceURL: string = environment.WMS_Service_URL;

    constructor(protected httpClient: HttpClient) { }

    getInitJanCommonReports(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitJanCommonReports";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitNgrInvoices(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitNgrInvoiceReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadJanCommonReports(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportJanCommonReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitNgrCommonReports(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitNgrCommonReports";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadNgrCommonReports(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportNgrCommonReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadTransactionList(model: any): Observable<HttpEvent<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/" + model.Url;
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            reportProgress: true,
            responseType: 'blob',
            observe: 'events'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitFedInvoices(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitFedInvoices";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadFedInvoices(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportFedInvoiceReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadNgrInvoices(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportNgrInvoiceReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitPukalAccReports(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitFedPukalAccReports";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadFedPukalAccReports(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportFedPukalAccReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadSwkPukalAccReports(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportSwkPukalAccReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitOthInvoices(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitOthInvoiceReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitOthCommonReports(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitOthCommonReports";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadOthCommonReports(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportOthCommonReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getAaAccounts(model: any): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetAaAccount";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response',
            params: new HttpParams()
                .set('accOffCode', model)
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadOthInvoices(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportOthInvoiceReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadSwkInvoices(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportSwkInvoiceReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    getInitSwkCommonReports(): Observable<HttpResponse<Object>> {
        let url = this.reportServiceURL + "api/ReportsManager/GetInitSwkCommonReports";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.get(url, {
            headers: header,
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    downloadSwkCommonReports(model: any): Observable<HttpResponse<Blob>> {
        let url = this.reportServiceURL + "api/ReportsManager/ExportSwkCommonReport";
        let header = new HttpHeaders({ 'Content-Type': 'application/json', 'X-WMS-Token': sessionStorage["token"] });

        return this.httpClient.post(url, model, {
            headers: header,
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            retry(3), // retry a failed request up to 3 times
            catchError(this.handleError) // then handle the error
        );
    }

    private handleError(error: Response | any): Observable<any> {
        // In a real world app, we might use a remote logging infrastructure
        if (error instanceof Response) {
            // const body = error.json() || '';
            // const err = body.error || JSON.stringify(body);
            // errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            console.error(error);
            return Observable.throw(error);
        } else {
            let errMsg: string;
            errMsg = error.message ? error.message : error.toString();
            console.error(errMsg);
            return Observable.throw(errMsg);
        }
    }
}